import { getAuthenticatedAxios } from "../../../utils/api";

export async function fetchSearchModeSettings() {
  const authAxios = getAuthenticatedAxios();
  const response = await authAxios.get("/api/v2/search/settings");
  return response.data;
}
